import type { IListGoogleHealthDataPointsResponse } from "./types";

/** Normaliza respostas do proxy ou da API direta para `{ dataPoints, nextPageToken }`. */
export function normalizeDataPointsListResponse(
  raw: unknown
): IListGoogleHealthDataPointsResponse {
  if (!raw || typeof raw !== "object") {
    return {};
  }

  const root = raw as Record<string, unknown>;

  if (Array.isArray(root.dataPoints)) {
    return {
      dataPoints: root.dataPoints as IListGoogleHealthDataPointsResponse["dataPoints"],
      nextPageToken:
        typeof root.nextPageToken === "string" ? root.nextPageToken : undefined,
    };
  }

  const nested = root.data;
  if (nested && typeof nested === "object") {
    const data = nested as Record<string, unknown>;
    if (Array.isArray(data.dataPoints)) {
      return {
        dataPoints: data.dataPoints as IListGoogleHealthDataPointsResponse["dataPoints"],
        nextPageToken:
          typeof data.nextPageToken === "string" ? data.nextPageToken : undefined,
      };
    }
  }

  const result = root.result;
  if (result && typeof result === "object") {
    return normalizeDataPointsListResponse(result);
  }

  return {};
}
